'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';
import { IconCheck } from '@tabler/icons-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-brand-input shadow-xs transition-[color,background-color,border-color,box-shadow] duration-200 outline-none focus-visible:border-brand-ring focus-visible:ring-[3px] focus-visible:ring-brand-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-brand-destructive aria-invalid:ring-brand-destructive/20 data-[state=checked]:border-brand-primary data-[state=checked]:bg-brand-primary data-[state=checked]:text-brand-primary-foreground',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        forceMount
        data-slot='checkbox-indicator'
        className='grid place-content-center text-current transition-[opacity,scale] duration-200 ease-out data-[state=unchecked]:scale-50 data-[state=unchecked]:opacity-0'
      >
        <IconCheck className='size-3.5 text-current' />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
